import type { ReactNode } from 'react';

export const symbol_location_searching: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-70v-45q-137-14-228-105T117-448H72q-13 0-21.5-8.5T42-478q0-13 8.5-21.5T72-508h45q14-137 105-228t228-105v-45q0-13 8.5-21.5T480-916q13 0 21.5 8.5T510-886v45q137 14 228 105t105 228h45q13 0 21.5 8.5T918-478q0 13-8.5 21.5T888-448h-45q-14 137-105 228T510-115v45q0 13-8.5 21.5T480-40q-13 0-21.5-8.5T450-70Zm244.5-193.5Q784-353 784-478t-89.5-214.5Q605-782 480-782t-214.5 89.5Q176-603 176-478t89.5 214.5Q355-174 480-174t214.5-89.5Z"
		/>
	</svg>
);
